<template>
    <div>
        <button
            type="button"
            class="user-menu__link-create-account"
            data-testid="create-account-button"
            @click="openRegistrationModal"
        >
            Vytvořit účet
        </button>
        <button type="button" class="btn user-menu__btn-login" data-testid="login-button" @click="openLoginModal">
            Přihlásit
        </button>
    </div>
</template>

<script lang="ts" setup>
import useAuthenticationFlows from "@/account/composables/use-authentication-flows";

const { openLoginModal, openRegistrationModal } = useAuthenticationFlows();
</script>
